import { ForwardedRef, forwardRef, SVGProps } from 'react';

export const HelpIcon = forwardRef((
	props: SVGProps<SVGSVGElement>,
	ref: ForwardedRef<SVGSVGElement>,
) => (
	<svg width="20" height="20" viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
		<g clipPath="url(#clip0_519_27605)">
			<path
				d="M10.2154 6.68711C9.82742 6.62057 9.42846 6.69347 9.08912 6.8929C8.74979 7.09233 8.49198 7.40542 8.36137 7.77672C8.20864 8.21088 7.73288 8.43902 7.29872 8.28629C6.86457 8.13357 6.63642 7.6578 6.78915 7.22364C7.05037 6.48105 7.56598 5.85487 8.24465 5.45601C8.92332 5.05715 9.72125 4.91135 10.4971 5.04444C11.273 5.17752 11.9767 5.58089 12.4837 6.18312C12.9905 6.78522 13.268 7.54725 13.2669 8.33427C13.2666 9.60957 12.321 10.4518 11.6458 10.9019C11.2828 11.1439 10.9257 11.3219 10.6627 11.4388C10.53 11.4978 10.4182 11.5425 10.3377 11.5732C10.2973 11.5886 10.2646 11.6005 10.2408 11.6089L10.2119 11.6191L10.2027 11.6222L10.1994 11.6233L10.1982 11.6237C10.1982 11.6237 10.1971 11.6241 9.93359 10.8335L10.1971 11.6241C9.7605 11.7696 9.28856 11.5337 9.14302 11.097C8.99758 10.6607 9.23314 10.1891 9.6692 10.0432L9.68249 10.0386C9.69531 10.034 9.71632 10.0264 9.74435 10.0157C9.80054 9.9943 9.8841 9.96094 9.98577 9.91575C10.1915 9.82433 10.4594 9.68979 10.7213 9.51514C11.296 9.13203 11.6003 8.72446 11.6003 8.33351L11.6003 8.33227C11.6008 7.93867 11.4621 7.55757 11.2086 7.25645C10.9552 6.95534 10.6033 6.75365 10.2154 6.68711Z"
				fill="currentColor"
			/>
			<path
				d="M10.0002 13.3335C9.53992 13.3335 9.16683 13.7066 9.16683 14.1668C9.16683 14.6271 9.53992 15.0002 10.0002 15.0002H10.0085C10.4687 15.0002 10.8418 14.6271 10.8418 14.1668C10.8418 13.7066 10.4687 13.3335 10.0085 13.3335H10.0002Z"
				fill="currentColor"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M0.833496 10.0002C0.833496 4.93755 4.93755 0.833496 10.0002 0.833496C15.0628 0.833496 19.1668 4.93755 19.1668 10.0002C19.1668 15.0628 15.0628 19.1668 10.0002 19.1668C4.93755 19.1668 0.833496 15.0628 0.833496 10.0002ZM10.0002 2.50016C5.85803 2.50016 2.50016 5.85803 2.50016 10.0002C2.50016 14.1423 5.85803 17.5002 10.0002 17.5002C14.1423 17.5002 17.5002 14.1423 17.5002 10.0002C17.5002 5.85803 14.1423 2.50016 10.0002 2.50016Z"
				fill="currentColor"
			/>
		</g>
		<defs>
			<clipPath id="clip0_519_27605">
				<rect width="20" height="20" fill="white" />
			</clipPath>
		</defs>
	</svg>
));

HelpIcon.displayName = 'HelpIcon';
